/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Privacy_Table_Header_Legal_BasisInputs */

const en_privacy_table_header_legal_basis = /** @type {(inputs: Privacy_Table_Header_Legal_BasisInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Legal Basis`)
};

const de_privacy_table_header_legal_basis = /** @type {(inputs: Privacy_Table_Header_Legal_BasisInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rechtsgrundlage`)
};

const fr_privacy_table_header_legal_basis = /** @type {(inputs: Privacy_Table_Header_Legal_BasisInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Base juridique`)
};

const es_privacy_table_header_legal_basis = /** @type {(inputs: Privacy_Table_Header_Legal_BasisInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Base legal`)
};

const it_privacy_table_header_legal_basis = /** @type {(inputs: Privacy_Table_Header_Legal_BasisInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Base giuridica`)
};

const nl_privacy_table_header_legal_basis = /** @type {(inputs: Privacy_Table_Header_Legal_BasisInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rechtsgrond`)
};

const pl_privacy_table_header_legal_basis = /** @type {(inputs: Privacy_Table_Header_Legal_BasisInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Podstawa prawna`)
};

const fi_privacy_table_header_legal_basis = /** @type {(inputs: Privacy_Table_Header_Legal_BasisInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Oikeusperuste`)
};

const da_privacy_table_header_legal_basis = /** @type {(inputs: Privacy_Table_Header_Legal_BasisInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Retsgrundlag`)
};

const sv_privacy_table_header_legal_basis = /** @type {(inputs: Privacy_Table_Header_Legal_BasisInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rättslig grund`)
};

/**
* | output |
* | --- |
* | "Legal Basis" |
*
* @param {Privacy_Table_Header_Legal_BasisInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const privacy_table_header_legal_basis = /** @type {((inputs?: Privacy_Table_Header_Legal_BasisInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Privacy_Table_Header_Legal_BasisInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_privacy_table_header_legal_basis(inputs)
	if (locale === "fr") return fr_privacy_table_header_legal_basis(inputs)
	if (locale === "es") return es_privacy_table_header_legal_basis(inputs)
	if (locale === "it") return it_privacy_table_header_legal_basis(inputs)
	if (locale === "nl") return nl_privacy_table_header_legal_basis(inputs)
	if (locale === "pl") return pl_privacy_table_header_legal_basis(inputs)
	if (locale === "fi") return fi_privacy_table_header_legal_basis(inputs)
	if (locale === "da") return da_privacy_table_header_legal_basis(inputs)
	if (locale === "sv") return sv_privacy_table_header_legal_basis(inputs)
	return en_privacy_table_header_legal_basis(inputs)
});